<template>
    <!-- DESCR：用户登录后的视图页面 -->
    <div class="general-container">
        <Menu class="menu-box"></Menu>
        <div>
            <!-- 子页面路由视图(general) -->
            <router-view></router-view>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, reactive, watch, provide } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { StarFilled, ArrowDown, Delete,ArrowLeftBold } from '@element-plus/icons-vue'
import Menu from "@/components/Menu.vue"

const router = useRouter()
const store = useStore()

// 默认选项卡显示下标
const defaultactive = ref('/common/myconferences');
const isPresident = ref(0)
const language = ref(false)

onMounted(() => {
    isPresident.value = store.state.user.isPresident
})



</script>


<style lang="scss" scoped>
.general-container {
    padding: 0 15%;

    .menu-box {
        margin-bottom: 20px;
    }
}
</style>
